/* template */
<template minapp="mpx" xlang="wxml"><controllable-drawer-bottom title="购票提示" :show="(show)" @close="closeNoticeDrawer"><div :class="(noticeType && 'prompt')" class="card"><div class="card-notice">{{ noticeText }}</div><div :class="(noticeType && 'prompt')" class="notice-description">{{
        noticeDescription
      }}</div><buy-ticket-card :buttonType="(1)" :isDrawer="(true)" :from="(from)" :drawerPrice="(drawerPrice)" @check="check" @close="closeNoticeDrawer" @getServiceDescription="getServiceDescription" v-if="(noticeType === 0)"/><div class="prompt-card-main" v-else><div class="contact-group"><div v-for="(item, index) in (contactList)" :key="item.index" class="contact-item"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="12" height="14" viewBox="0 0 27 28" class="contact-icon"><g><g><ellipse cx="13.5" cy="9" rx="7.5" ry="7.5" fill-opacity="0" stroke-opacity="1" stroke="#222222" fill="none" stroke-width="3"/></g><g><path d="M1.076426,22.86691Q0,25.24567,0,28L3,28Q3,23.80043,6.00874,21.13807Q8.99003,18.5,13.5,18.5Q18.01,18.5,20.9913,21.13807Q24,23.80043,24,28L27,28Q27,25.24567,25.9236,22.86691Q24.8894,20.5816,22.9793,18.89137Q21.1245,17.250091,18.6761,16.37439Q16.2314,15.5,13.5,15.5Q10.76863,15.5,8.3239,16.374389Q5.8755,17.250092,4.02069,18.89137Q2.110558,20.5816,1.076426,22.86691Z" fill-rule="evenodd" fill="#222222" fill-opacity="1"/></g></g></svg><div class="contact-name">{{ item.passenger_name }}</div></div></div><mpx-view @tap="addPassenger" class="prompt-button">完善信息</mpx-view></div></div></controllable-drawer-bottom></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m1166b12f"}'>
  .card
    margin-top 24px
    display flex
    flex-direction column
    padding 0 20px 49px 20px
    &.prompt
      padding-bottom 39px
    &-notice
      font-family PingFangSC-Medium
      font-size 18px
      line-height 18px
      color #000
      margin-bottom 5px
    .notice-description
      font-family PingFangSC-Regular
      font-size 12px
      line-height 18px
      color #999
      margin-bottom 23px
      white-space pre-wrap
      &.prompt
        margin-bottom 16px
    .prompt-card-main
      display flex
      flex-direction column
      overflow-x hidden
      .contact-group
        display flex
        flex-direction row
        flex-wrap wrap
        margin-bottom 26px
        .contact-item
          display flex
          height 40px
          align-items center
          padding 0 16px
          margin-right 8px
          margin-bottom 8px
          border-radius 10px
          background #f6f9fd
          font-family PingFangSC-Medium
          font-size 16px
          line-height 16px
          color #333
          .contact-icon
            margin-right 8px
      .prompt-button
        padding 14.5px 0
        display flex
        justify-content center
        border-radius 10px
        color #fff
        background #FF6400
        line-height 15px
        font-family PingFangSC-Medium
      font-size 15px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1166b12f"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./ticketing-notice-drawer.mpx.js?isComponent&outputPath=components%2Fticketing-notice-drawer1166b12f%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./ticketing-notice-drawer.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fticketing-notice-drawer1166b12f%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m1166b12f"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/ticketing-notice-drawer1166b12f/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'buy-ticket-card':getComponent(require("../../train-detail/components/buy-ticket-card/index.mpx?isComponent&outputPath=components%2Findex29d740e6%2Findex")),'login-drawer-button':getComponent(require("./login-drawer-button.mpx?isComponent&outputPath=components%2Flogin-drawer-button109bbf0a%2Findex")),'controllable-drawer-bottom':getComponent(require("../../../components/controllable-drawer-buttom.mpx?isComponent&outputPath=components%2Fcontrollable-drawer-buttomcb57d2b4%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
